export default "__VITE_ASSET__P8Dkcwdr__"